import { useDebounce } from '@hooks';
import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { message } from 'antd';
import { useState } from 'react';

import { linkShortnerApi } from '../api/linkShortnerApi';
import {
  CreateLinkParams,
  ShortenedLink,
  UpdateLinkParams,
} from '../typings/linkShortner';
export const useShortenedLinks = (searchParam: string) => {
  const [page, setPage] = useState(0);
  const debouncedSearch = useDebounce(searchParam, 900);
  const queryClient = useQueryClient();

  const { data = [], isLoading } = useQuery({
    queryKey: ['shortenedLinks', debouncedSearch, page],
    queryFn: () =>
      linkShortnerApi.fetchLinks({
        page,
        search: debouncedSearch.trim().replace(/\s+/g, '%') || undefined,
      }),
    placeholderData: keepPreviousData,
  });

  const createLinkMutation = useMutation<
    ShortenedLink,
    unknown,
    CreateLinkParams
  >({
    mutationFn: linkShortnerApi.createLink,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shortenedLinks'] });
      message.success('Link criado com sucesso!');
    },
    onError: () => {
      message.error('Não foi possivel criar o link. Tente novamente');
    },
  });

  const updateLinkMutation = useMutation<
    ShortenedLink,
    unknown,
    UpdateLinkParams
  >({
    mutationFn: linkShortnerApi.updateLink,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shortenedLinks'] });
      message.success('Link atualizado com sucesso!');
    },
    onError: () => {
      message.error('Não foi possível atualizar o link. Tente novamente');
    },
  });

  const deleteLinkMutation = useMutation<void, unknown, string>({
    mutationFn: linkShortnerApi.deleteLink,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shortenedLinks'] });
      message.success('Link deletado com sucesso!');
    },
    onError: () => {
      message.error('Falha ao deletar o link.');
    },
  });
  const handleUpdatePage = (newPage: number) => {
    setPage(newPage - 1);
  };

  return {
    data,
    isLoading,
    currentPage: page + 1,
    handleUpdatePage,
    createLink: createLinkMutation.mutateAsync,
    createLinkLoading: createLinkMutation.isPending,
    deleteLink: deleteLinkMutation.mutateAsync,
    updateLink: updateLinkMutation.mutateAsync,
    updateLinkLoading: updateLinkMutation.isPending,
  };
};
